import { useState } from 'react';
import { useAppState } from '../context/OmniboxCsvConverterContext';
import { readFile } from '../omnibox_csv_converter/converterHelperFunctions';
import {
  Box,
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  Snackbar,
  Stack,
  Typography,
} from '@mui/material';
import { RenderOutputTable } from '../omnibox_csv_converter';

function OmniboxCsvConverterPage() {
  const { selectedFile, delimString, unitSystem, setSelectedFile, setUnitSystem, setProdLines, setDelimString } = useAppState();
  const [fileExists, setFileExists] = useState(false);
  const [alert, setAlert] = useState(false);

  const handleFileChange = async (event) => {
    setSelectedFile(event.target.files[0]);
    const result = await readFile(event.target.files[0], unitSystem);

    setProdLines(result.prodLines);
    setDelimString(result.delimString);
    if (result.prodLines.length > 0) setFileExists(true);
  }

  const handleUnitChange = (event) => {
    setUnitSystem(event.target.value);
  }

  const handleCopyToCB = () => {
    let cbText = '';
    let resultsLine = delimString.split('\r\n');
    let pastHeader = false;

    for (const line of resultsLine) {
      if (pastHeader === false) {
        pastHeader = true;
      }
      else {
        let lineValues = line.split('\t');
        let cbLine = '';
        for (let i = 0; i < lineValues.length; i++) {
          let val = lineValues[i];
          cbLine += val + '\t';
        }
        cbText += cbLine + '\r\n';
      }
    }

    navigator.clipboard.writeText(cbText);
    setAlert(true);
  }

  return (
    <Box>
      <Typography variant='h4' fontWeight={700} sx={{ mb: 1 }}>
        Omnibox CSV Converter
      </Typography>
      <Typography variant='body1' color='text.secondary' sx={{ mb: 4 }}>
        Convert Omnibox summary CSV files to tab delimited text to be pasted into production tracking templates.
      </Typography>

      <Paper
        sx={{
          p: 4,
          backgroundColor: 'background.paper'
        }}
      >
        <Stack direction='row' alignItems='center' spacing={4}>
          <Stack direction='row' spacing={1} alignItems='center'>
            <Typography variant='body1'>Omnibox source file UM:</Typography>
            <Select label='UM' variant='standard' onChange={handleUnitChange} value={unitSystem} sx={{ width: '100px' }}>
              <MenuItem value='metric'>Metric</MenuItem>
              <MenuItem value='imperial'>Imperial</MenuItem>
            </Select>
          </Stack>
          <Button variant='contained' component='label' sx={{ width: 'auto', fontSize: '12px' }}>
            Select CSV File
            <input type='file' accept='.csv' hidden onChange={handleFileChange} />
          </Button>

        </Stack>

        {fileExists && (
          <Stack direction='column' sx={{ mt: 2 }}>
            <Button variant='outlined' onClick={handleCopyToCB}>Copy to Clipboard</Button>
            <Snackbar 
              open={alert}
              autoHideDuration={3000}
              onClose={() => setAlert(false)}
              message='Results copied to clipboard'
            />
          </Stack>
        )}

      </Paper>

      { fileExists && <RenderOutputTable /> }
    </Box>
  )
}

export default OmniboxCsvConverterPage;